import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { EmailVerifyBanner } from '@/components/auth/EmailVerifyBanner';
import { TrialBanner } from '@/features/billing/TrialBanner';
import { BudgetWarningBanner } from '@/features/billing/BudgetWarningBanner';
import { CancelScheduledBanner } from '@/features/billing/CancelScheduledBanner';
import { DpaBanner } from '@/components/DpaBanner';
import { useServerLocaleSync } from './useServerLocaleSync';

/*
 * AppLayout
 *
 * Mockup: luviamo_app_mockup_v0_2_expanded_sidebar_avustaja.html
 *
 * Rakenne:
 * - Vasen Sidebar (220px, kiinteä leveys)
 * - Yläpalkki Header (52px korkea, nav + leivänmurut + haku + käyttäjä)
 * - EmailVerifyBanner (Sessio 6b, nakyy vain jos email_verified_at IS NULL)
 * - Pääsisältöalue (Outlet, vaihtuva moduuli)
 * - Avustaja-paneeli (oikealla, slide-in, lisätään Vaiheessa 7)
 *
 * Kuoren korkeus ja vieritys (13.9.2026, Joanna Mac/Chrome + iPhone/Safari -kaava):
 * - `h-dvh`, ei `h-screen`: iOS Safarissa 100vh on ikkunan SUURIN korkeus (URL-palkki
 *   piilossa), joten 100vh-kuori on aina näkyvää aluetta korkeampi ja html jää vieritettäväksi.
 * - html lukitaan `overflow: hidden` kuoren eliniäksi: kaikki vieritys tapahtuu `main`issa, joten
 *   html-tason vieritys on aina virhe (Seuraa-sivun "tyhjä alaosa": header + sivupalkki vierivät
 *   ylös). Auth-sivut ovat kuoren ulkopuolella (`min-h-screen`) ja pysyvät vieritettävinä.
 * - `overscroll-y-none` mainissa: vieritys ei ketjuunnu mainin pohjasta html:ään.
 */
export function AppLayout() {
  // Sovella serverin kielivalinta (users.locale) kerran per lataus -- laitteiden valinen synkka.
  useServerLocaleSync();
  useEffect(() => {
    const html = document.documentElement;
    const prev = html.style.overflow;
    html.style.overflow = 'hidden';
    return () => {
      html.style.overflow = prev;
    };
  }, []);
  return (
    <div className="flex h-dvh w-screen overflow-hidden bg-usva text-teksti">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <EmailVerifyBanner />
        <TrialBanner />
        <BudgetWarningBanner />
        <CancelScheduledBanner />
        <DpaBanner />
        <main className="flex-1 overflow-y-auto overscroll-y-none">
          <div className="mx-auto w-full max-w-[var(--content-max)] px-6 py-8 lg:px-10">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
